import React from "react";
import Modal from "../../ModalOld";
import Button from "../../Button";
import { Title, Actions, IconBox } from "./styles";
import { ConfirmModalProps } from "./types";
import { Icon } from "../../Icon/styles";
import COLORS from "../../../designSystem/colors";

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  message,
  leftButtonText = "Cancel",
  rightButtonText = "Confirm",
  rightButtonColor,
  imagePath,
  imageHeight = "40px",
  imageBackgroundColor
}) => {
  return (
    <Modal
      modalOpen={open}
      setModalOpen={onClose}
      id="confirmModal"
      extraStyles={{
        padding: "0",
        borderRadius: "12px",
        width: "30%",
        minWidth: 340,
        maxWidth: 400,
        backgroundColor: "#fff",
        boxShadow: "0 4px 32px rgba(0,0,0,0.15)",
        overflow: "visible",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <IconBox imageBackgroundColor={imageBackgroundColor}>
        <Icon src={imagePath} alt="Icon" height={imageHeight} />
      </IconBox>
      <div
        style={{
          flex: "1 1 auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10px 24px 0 24px",
        }}
      >
        <Title>{message}</Title>
      </div>
      <div style={{ borderBottom: "1px solid #E5E7EB", margin: "10px 0 0 0" }} />
      <Actions>
        <Button
          text={leftButtonText}
          $background={COLORS.UI.BUTTON.PRIMARY.BACKGROUND}
          $color="#374151"
          $bold={true}
          $height="40px"
          handleClick={onClose}
        />
        <Button
          text={rightButtonText}
          $background={rightButtonColor || COLORS.UI.BUTTON.DANGER.BACKGROUND}
          $color="#fff"
          $bold={true}
          $height="40px"
          handleClick={onConfirm}
        />
      </Actions>
    </Modal>
  );
};

export default ConfirmModal;
